import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';

import LocalFormBlockData from './Data';
import LocalFormBlockView from './View';

const LocalFormBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      <LocalFormBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <LocalFormBlockData
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(LocalFormBlockEdit);
